module.exports = __webpack_public_path__ + "assets/media/android-img.bd04385b.jpg";